import { render, staticRenderFns } from "./TabFive.vue?vue&type=template&id=0afaccdd&scoped=true&"
import script from "./TabFive.vue?vue&type=script&lang=js&"
export * from "./TabFive.vue?vue&type=script&lang=js&"
import style0 from "./TabFive.vue?vue&type=style&index=0&id=0afaccdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaccdd",
  null
  
)

export default component.exports